import {BasicService} from './basic.service';

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_PRODUCT_URL } from '../../connection.data';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ProductService extends BasicService {

    constructor(http: HttpClient){
        super(http);
        this.baseUrl = API_PRODUCT_URL;
    }

    /** Obtiene productos de la empresa seleccionada. */
    getAll(options?: {company_id?: number}): Observable<any[]> {
        if (!options || options.company_id == null) return super.getAll();

        const params = new HttpParams().set('company_id', String(options.company_id));
        return this.http.get<{rows: any[]}>(`${this.baseUrl}/all`, {params}).pipe(
            map(response => response.rows || [])
        );
    }
}
